import { useEffect, useState } from "react";
import { GameConfigContext, GamePlayerContext, LocalPlayerContext } from "../../../context/game-context";
import { Button, Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { CheckActivation } from "@redux/actions/auth/user-activation.actions";
import { useParams } from "react-router-dom";
import { ResendActivation } from "@redux/actions/auth/user-activation.actions";
import { useAuthBasicService } from "../../../../blockhain/provider/initiate.provider";
import { CheckPasswordCode } from "@redux/actions/auth/forgot-password.actions";
import { ChangePassword, RequestForgotPasswordLink, RequestForgotPasswordLinkByCode } from "@redux/actions/auth/forgot-password.actions";
import { Field, Form, Formik } from "formik";
import * as Yup from 'yup';


export default function PasswordReset() {
    let { passwordCode } = useParams();
    const setLoading = GameConfigContext((state) => state.setLoading);

    const [isSubmitting, setSubmitting] = useState(false);

    const onRequest = useSelector((state) => state.ForgotPassword.onRequest)
    const forgotPasswordState = useSelector((state) => state.ForgotPassword.forgotPasswordState)
    const userData = useSelector((state) => state.ForgotPassword.data)
    const dispatch = useDispatch();

    const checkActivation = async () => {

        const checkActivation = await CheckPasswordCode(passwordCode);

        dispatch(checkActivation)
        // setToken(token);
    }

    const resendResetPasswordLink = async () => {

        const requestForgot = await RequestForgotPasswordLinkByCode(passwordCode);

        dispatch(requestForgot)
    }

    useEffect(() => {
        setLoading(false, null);
        checkActivation();
    }, [])

    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .min(6, 'Password must be at least 6 characters')
            .required('Password is required'),
        confPassword: Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required('Confirm Password is required'),
    });

    const initialValues = {
        password: '',
        confPassword: '',
    };

    const handleSubmit = async (values, actions) => {
        const checkActivation = await ChangePassword(passwordCode, values.password);

        dispatch(checkActivation)
    };

    return (
        <>
            <div className="landing container-fluid">
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className='col-md-6'>
                            <div className='card' style={{ maxWidth: '500px' }}>
                                <div className='card-body'>
                                    <h5 className='my-3 fw-bold'>
                                        Reset Password
                                    </h5>
                                    <hr />
                                    {onRequest && <>
                                        <Spinner size='md' />
                                        <p className='text-center mt-2'>Sedang Memuat, Mohon Tunggu ...</p>
                                    </>}
                                    {(!onRequest && forgotPasswordState == "success_validate") &&
                                        <Formik
                                            initialValues={initialValues}
                                            validationSchema={validationSchema}
                                            onSubmit={handleSubmit}
                                        >
                                            {({ setFieldValue, errors, touched }) => (
                                                <Form className={`p-0 ${errors && touched && 'needs-validated'}`}>
                                                    <div className='row mb-3'>
                                                        <Field type="password" name="password" placeholder="Kata Sandi" className={`form-control ${(touched.password && errors.password) && 'is-invalid'}`} />

                                                        {errors.password && touched.password && (
                                                            <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.password}</div>
                                                        )}
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <Field type="password" name="confPassword" placeholder="Konfirmasi Kata Sandi" className={`form-control ${(touched.confPassword && errors.confPassword) && 'is-invalid'}`} />

                                                        {errors.confPassword && touched.confPassword && (
                                                            <div className="invalid-feedback p-0" style={{ display: 'block' }}>{errors.confPassword}</div>
                                                        )}
                                                    </div>

                                                    <Button variant="primary" type="submit" disabled={isSubmitting} className={"w-100"}>
                                                        Ubah Password
                                                    </Button>
                                                </Form>
                                            )}
                                        </Formik>
                                    }
                                    {(!onRequest && forgotPasswordState == "error") &&
                                        <div>
                                            <FontAwesomeIcon icon="far fa-circle-xmark" className="text-danger mb-4" style={{ fontSize: '60px' }} />
                                            <h6>Gagal! proses reset password akun anda gagal, klik dibawah
                                                untuk mengirimkan ulang link reset password.</h6>
                                            <p className="mt-3">
                                                <a href='#' onClick={() => resendResetPasswordLink()} className='btn btn-primary w-100'>Kirim ulang reset password</a></p>
                                        </div>
                                    }
                                    {(!onRequest && forgotPasswordState == "request_success") &&
                                        <div>
                                            <FontAwesomeIcon icon="fa fa-envelope-circle-check" className="text-primary mb-4" style={{ fontSize: '60px' }} />
                                            <h6>Link reset kata sandi telah terkirim ke email anda</h6>
                                            <p className="mt-3">
                                                <a href='/' className='btn btn-primary w-100'>Ok</a></p>
                                        </div>
                                    }
                                    {(!onRequest && forgotPasswordState == "success") &&
                                        <div>
                                            <FontAwesomeIcon icon="far fa-check-circle" className="text-primary mb-4" style={{ fontSize: '60px' }} />
                                            <h6>Selamat! Anda telah berhasil melakukan reset password,
                                                sekarang anda dapat melakukan login melalui akun anda dengan password yang baru</h6>
                                            <p className="mt-3">
                                                <a href='/' className='btn btn-primary w-100'>OK, Eksplore Museum Virtual</a></p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
